export default __webpack_public_path__ + "resources/icons/n241-46b5.webp";